<template>
  <div :style="{ display: 'flex', flexDirection: 'column', height: 'inherit' }">
    <div id="chattool" class="text-xs-center">
      <v-tabs
        v-model="chattooltype"
        color="grey lighten-3"
        :slider-color="$vuetify.theme.primary"
        show-arrows
      >
        <v-tab :key="'customer'" ripple :href="'#customer'">{{ $t('Info') }}</v-tab>
        <v-tab :key="'ticket'" ripple :href="'#ticket'">{{ $t('Ticket') }}</v-tab>
        <v-tab
          v-if="$store.state.beavermanpage.includes(currentPageid)"
          :key="'beavermancontract'"
          ripple
          :href="'#beavermancontract'"
          >{{ $t('Contact') }}</v-tab
        >
        <v-tab v-if="livechatTheme == 'nvbb'" :key="'quota'" ripple :href="'#quota'">{{
          $t('Quota')
        }}</v-tab>
        <v-tab
          v-if="livechatTheme == 'scgworkplace'"
          :key="'workplacecustomer'"
          ripple
          :href="'#workplacecustomer'"
          >{{ $t('Workplace') }}</v-tab
        >
        <v-tab
          v-if="livechatTheme == 'scgallrent' && allrentcustomer && allrentcustomer.length"
          :key="'allrentcustomer'"
          ripple
          :href="'#allrentcustomer'"
          >{{ $t('Customer') }}</v-tab
        >
        <v-tab
          v-if="$store.state.toacustomerpage.includes(currentPageid)"
          :key="'toapaintcustomer'"
          ripple
          :href="'#toapaintcustomer'"
          >{{ $t('Paint') }}</v-tab
        >
        <v-tab
          v-if="$store.state.toacustomerpage.includes(currentPageid)"
          :key="'toapaintercustomer'"
          ripple
          :href="'#toapaintercustomer'"
          >{{ $t('Painter') }}</v-tab
        >
        <v-tab
          v-if="livechatTheme == 'scgallrent' && allrentsupplier && allrentsupplier.length"
          :key="'allrentsupplier'"
          ripple
          :href="'#allrentsupplier'"
          >{{ $t('Supplier') }}</v-tab
        >
        <v-tab
          v-if="
            $store.state.nestlePages.some((page) => page.pageid == selectedBot.pageid) ||
            ['cityfresh'].includes(livechatTheme) ||
            ['dtac-gaming'].includes(selectedBot.type) ||
            isTremendous
          "
          :key="'ordersummary'"
          ripple
          :href="'#ordersummary'"
        >
          {{ $t('Order Summary') }}
        </v-tab>
        <v-tab
          v-if="
            $store.state.nestlePages.some((page) => page.pageid == selectedBot.pageid) ||
            ['cityfresh'].includes(livechatTheme)
          "
          :key="'currentcart'"
          ripple
          :href="'#currentcart'"
        >
          {{ $t('Current Cart') }}
        </v-tab>
        <!-- <v-tab ripple :key="'conversation'" :href="'#conversation'">{{$t('Conversation')}}</v-tab> -->
      </v-tabs>
    </div>

    <div :style="{ overflowY: 'auto', flex: 1 }">
      <template v-if="chattooltype == 'ticket'">
        <ticket-list
          :key="`ticket_list_${selectedUser.user_id}_${selectedUser.type}`"
          v-model="selectedUser.user_id"
          :pageid="selectedUser.page_id"
          :selected-user="selectedUser"
        ></ticket-list>
      </template>
      <div v-if="chattooltype == 'customer'">
        <livechat-customers
          :key="`customer_detail_${selectedUser.userid}_${selectedUser.type}`"
          v-model="selectedUser"
          :theme="livechatTheme"
          :pageid="$store.state.livechat.pageid"
        ></livechat-customers>
      </div>
      <div v-if="chattooltype == 'workplacecustomer'">
        <scgworkplace-customer
          :key="`customer_detail_${selectedUser.userid}_${selectedUser.type}`"
          v-model="selectedUser.userid"
          :pageid="$store.state.livechat.pageid"
        ></scgworkplace-customer>
      </div>
      <div v-if="chattooltype == 'toapaintcustomer'">
        <ToaPaintCustomer
          :key="`customer_detail_${selectedUser.userid}_${selectedUser.type}`"
          v-model="selectedUser.userid"
          :pageid="$store.state.livechat.pageid"
        ></ToaPaintCustomer>
      </div>
      <div v-if="chattooltype == 'toapaintercustomer'">
        <ToaPainterCustomer
          :key="`customer_detail_${selectedUser.userid}_${selectedUser.type}`"
          v-model="selectedUser.userid"
          :pageid="$store.state.livechat.pageid"
        ></ToaPainterCustomer>
      </div>
      <div v-if="chattooltype == 'allrentcustomer'">
        <ScgAllrentCustomer
          :key="`customer_detail_${selectedUser.userid}_${selectedUser.type}`"
          v-model="selectedUser"
          :pageid="$store.state.livechat.pageid"
          :userid="selectedUser.userid"
        ></ScgAllrentCustomer>
      </div>
      <div v-if="chattooltype == 'quota'">
        <NvbbQuota
          :key="`customer_detail_${selectedUser.userid}_${selectedUser.type}`"
          v-model="selectedUser"
          :pageid="$store.state.livechat.pageid"
          :userid="selectedUser.userid"
        ></NvbbQuota>
      </div>
      <div v-if="chattooltype == 'allrentsupplier'">
        <ScgAllrentSupplier
          :key="`customer_detail_${selectedUser.userid}_${selectedUser.type}`"
          v-model="selectedUser"
          :pageid="$store.state.livechat.pageid"
          :userid="selectedUser.userid"
        ></ScgAllrentSupplier>
      </div>
      <div v-if="chattooltype == 'beavermancontract'">
        <BeavermanContract
          :key="`customer_detail_${selectedUser.userid}_${selectedUser.type}`"
          v-model="selectedUser"
          :pageid="$store.state.livechat.pageid"
          :userid="selectedUser.userid"
        ></BeavermanContract>
      </div>
      <div v-else-if="chattooltype == 'conversation'">
        <div class="pa-1 form-control">
          <input type="text" class="form-control" :placeholder="$t('Search')" />
        </div>
      </div>
      <div v-else-if="chattooltype == 'ordersummary'">
        <livechat-order-summary
          :key="`customer_order_${selectedUser.userid}_${selectedUser.type}`"
        ></livechat-order-summary>
      </div>
      <div v-else-if="chattooltype == 'currentcart'">
        <livechat-currentcart
          :key="`customer_currentcart_${selectedUser.userid}_${selectedUser.type}`"
        ></livechat-currentcart>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ScgworkplaceCustomer from './scgworkplace-customer.vue'
import ScgAllrentCustomer from './scgallrent-customer.vue'
import ScgAllrentSupplier from './scgallrent-supplier.vue'
import NvbbQuota from './NvbbQuota.vue'
import LivechatCustomers from './livechat-customers'
import TicketList from './TicketList'
import ToaPaintCustomer from './ToaPaintCustomer.vue'
import ToaPainterCustomer from './ToaPainterCustomer.vue'
import BeavermanContract from './BeavermanContract.vue'
import LivechatOrderSummary from './livechat-order-summary'
import LivechatCurrentcart from './livechat-currentcart'
import api from '@/api'
import { PAGE } from '@/constants/page.js'

export default {
  components: {
    ScgworkplaceCustomer,
    ScgAllrentCustomer,
    ScgAllrentSupplier,
    NvbbQuota,
    LivechatCustomers,
    TicketList,
    ToaPaintCustomer,
    ToaPainterCustomer,
    BeavermanContract,
    LivechatOrderSummary,
    LivechatCurrentcart
  },
  props: ['selectedUser'],
  data() {
    return {
      chattooltype: 'customer',
      allrentcustomer: [],
      allrentsupplier: []
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    livechatTheme() {
      return this.$store.state.livechat.theme
    },
    currentPageid() {
      return this.$store.state.livechat.pageid
    },
    isTremendous() {
      return PAGE.TREMENDOUS.includes(this.selectedBot.pageid)
    }
  },
  watch: {
    selectedUser: function (newVal, oldVal) {
      var vm = this
      if (newVal != oldVal) {
        if (this.livechatTheme == 'scgallrent') {
          vm.getallrenttransactionlivechat()
        }
      }
    }
  },
  mounted() {
    var vm = this
    if (this.livechatTheme == 'scgallrent') {
      vm.getallrenttransactionlivechat()
    }
    if (vm.livechatTheme == 'scgworkplace') {
      vm.chattooltype = 'workplacecustomer'
    }
    if (vm.livechatTheme == 'ticket') {
      // vm.chattooltype = 'ticket'
    }
  },
  methods: {
    getallrenttransactionlivechat() {
      if (this.selectedUser && this.selectedUser.userid) {
        var data = {
          pageid: this.$store.state.livechat.pageid,
          userid: this.selectedUser.userid
        }
        api.getallrenttransactionlivechat(data, (err, response) => {
          if (response.responsecode == 200) {
            this.allrentcustomer = response.data
            this.allrentsupplier = response.data2
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-chattool.vue